<template>
<div class="tableScope">
	<!--
	<div class="bdSub-bottom pd1x">
		<Select :list="getTypeText('','deviceState',true)" :keyMap="{text:'name'}"></Select>
	</div>
	 -->
	<Confirm ref="confirm" @confirm="del"></Confirm>
	<edit-child-sys-device :selectChildSystem="stationId?true:false" @editSuccess="editSuccess" ref="editChildSysDevice"></edit-child-sys-device>
	<div class="table table-5x tra-fast posR bgContent" fillHeight="lastHeight,-.inverterListHeight">
		<Loading ref="Loading"></Loading>
		<div class="cb" v-show="pagination.total>0">
			<div class="scrollHide tra-fast fL bdLight-right" :style="{'width':stage.setting.system.autoColumnWidth[0]*floatColumn.length*.7+stage.setting.system.autoColumnWidth[1]}" scrollFloatX="false" fillHeight="lastHeight,-.inverterListHeight">
				<div class="tableSys head noSelect b cField bdLight-bottom tra-fast_E" scrollFloatY="false">
					<div v-if="stationId" class="w4x"></div>
					<!-- <div :title="getLanguageStr('word1784','名称/SN号')">{{getLanguageStr('word1784','名称/SN号')}}</div> -->
					<div :class="{cMain:order.property=='device_sn'}" class="sequence" :title="getLanguageStr('word1784','名称/SN号')" @click="Order('device_sn')"><span>{{getLanguageStr('word1784','名称/SN号')}}</span>
						<span :sequence="order.property=='device_sn'? order.direction:''"></span>
					</div>
				</div>
				<div class="fixedScrollBar scrollY tra-fast" fillHeight="lastHeight,-.inverterListHeight" scroll="{'group':'a'}">
					<table>
						<tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
						<tr v-for="(plant,index) in list" :key="index">
							<td v-if="stationId" class="selectColumn w4x">
								<Checkbox v-model="plant.isSelect" :index="index" @Click="selectData"></Checkbox>
							</td>
							<td class="curP" @click.stop="view(plant)">
								<div :title="plant.name||getLanguageStr('word35','逆变器')">{{plant.name||getLanguageStr('word35','逆变器')}}</div>
								<div class="cSub" :title="plant.serialNumber ">
									{{plant.serialNumber}}
								</div>
							</td>
							<!-- <td :class="{cMain:orderBy=='name','tra-fast':true}" class="curP">
								<div :title="plant.name||''">{{plant.name}}</div>
								<div class="cSub" :title="plant.serialNumber ">
									{{plant.serialNumber}}
								</div>
							</td> -->
						</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="operate scrollHide" :class="{'operate-2x':stationId,'operate-3x':!stationId}" fillHeight="lastHeight,-.inverterListHeight" :mode="stage.setting.loc.operateMode" v-if="moreBtnFlag">
				<div class="tableSys head noSelect b cField bdLight-bottom bgContent tra-fast_E" scrollFloatY="false">
					<div class="cb vaM_E">
						<button class="fa fa-angle-double-right hover-c-main" :title="$t('cmd108',['点击展开/收起'])" @click="operateModeChange" type="button"></button>
						<span class="dpIB lh20" :title="$t('word47',['操作'])">{{$t("word47",["操作"])}}</span>
						<!-- <button class="sizeS mr1x bdSub boxR cField pl05x pr05x hover-primary fR" type="button">{{getLanguageStr('all19','自定义列')}}</button> -->
					</div>
				</div>
				<div class="fixedScrollBar scrollY tra-fast bgContent" fillHeight="lastHeight,-.inverterListHeight" scroll="{'group':'a'}">
					<table>
						<thead class="head-token">
						<tr>
							<th></th>
						</tr>
						</thead>
						<tbody class="bdLight-bottom_E textCut_EE">
						<tr v-for="(plant,index) in list" :key="index">
							<td class="cSub fSub w3x_E mr05x_E hover-f-primary_E tra-fast_E vaM_E">
								<button v-if="!stationId" v-permissions="'A/B/A6'" permission-type="none" @click="viewPlant(plant)" :title="$t('plant_device2',['系统'])" type="button">
									<Icon name="link" class="ico"/>
								</button>
								<button type="button" @click="editDeviceInfo(plant)" :title="$t('cmd8',['编辑'])" v-permissions="'A/B/A9'" permission-type="none" v-if="doPermissions('A/B/A9',{targetCode:'A5',codeList:clone(plant.roleCode||roleCode)})">
									<Icon name="edit" class="ico"/>
								</button>
								<button class="hover-c-error hover-f-error" type="button" @click="confirmDel(plant)" :title="$t('cmd9',['删除'])" v-permissions="'A/B/A10'" permission-type="none" v-if="doPermissions('A/B/A10',{targetCode:'A6',codeList:clone(plant.roleCode||roleCode)})">
									<Icon name="recycle" class="ico"/>
								</button>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div scroll="{'axis':'x'}">
				<div class="tableSys head noSelect b cField bdLight-bottom"
					:style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}"
					scrollFloatY="false">
					<!--<div class="w7x taC" :title="$t('word1460',['通讯状态'])">{{$t('word1460',['通讯状态'])}}</div>
					<div class="w9x taC" :title="getLanguageStr('word1658','报警状态')">{{getLanguageStr('word1658','报警状态')}}</div>-->
					<div class="w9x taC" :title="$t('word166',['状态'])">{{$t('word166',['状态'])}}</div>
					<div class="w12x" :title="getLanguageStr(stationId?'word1785':'plant278','所属系统:所属电站')">{{getLanguageStr(stationId?'word1785':'plant278','所属系统:所属电站')}}</div>
					<!-- <div :class="{cMain:order.property=='name'}" class="sequence" :title="getLanguageStr('word1784','名称/SN号')" @click="Order('name')"><span>{{getLanguageStr('word1784','名称/SN号')}}</span>
						<span :sequence="order.property=='name'? order.direction:''"></span>
					</div> -->
					<div :class="{cMain:order.property=='generation_power'}" class="sequence" :title="getLanguageStr('word176','发电功率')+'(kW)'" @click="Order('generation_power')">
						<span>{{getLanguageStr('word176','发电功率')+'(kW)'}}</span>
						<span :sequence="order.property=='generation_power'? order.direction:''"></span>
					</div>
					<div :class="{cMain:order.property=='generation'}" class="sequence" :title="$t('word358',['当日发电量'])+'(kWh)'" @click="Order('generation')">
						<span>{{$t("word358",["当日发电量"])+'(kWh)'}}</span>
						<span :sequence="order.property=='generation'? order.direction:''"></span>
					</div>
					<div :title="getLanguageStr('word1522','所属父设备')">{{getLanguageStr('word1522','所属父设备')}}</div>
					<div :title="getLanguageStr('word1907','父设备状态')">{{getLanguageStr('word1907','父设备状态')}}</div>
			<!--		<div :title="getLanguageStr('plant_detail143','父设备通讯状态')">{{getLanguageStr('plant_detail143','父设备通讯状态')}}</div>-->
					<div :class="{cMain:order.property=='collection_time'}" class="sequence" :title="getLanguageStr('word1715','数据更新时间')" @click="Order('collection_time')">
						<span>{{getLanguageStr('word1715','数据更新时间')}}</span>
						<span :sequence="order.property=='collection_time'? order.direction:''"></span>
					</div>
				</div>
				<div class="fixedScrollBar scrollY tra-fast" fillHeight="lastHeight,-.inverterListHeight" scroll="{'group':'a'}">
					<table :style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}">
						<thead class="head-token">
						<tr>
							<!--<th class="w7x"></th>-->
							<th class="w9x"></th>
							<th class="w12x"></th>
							<th></th>
							<th></th>
							<th></th>
							<th></th>
							<th></th>
						</tr>
						</thead>
						<tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
						<tr v-for="(plant,index) in list" :key="index">
							<!--<td class="taC">
								<span v-if="plant.netState==null">--</span>
								<StatusIco v-else :id="plant.netState" :type="'device'"></StatusIco>
							</td>-->
							<!-- 通讯状态 -->
							<!--<td class="taC">
								<span v-if="plant.alertState==null">--</span>
								<StatusIco v-else :id="plant.alertState" :type="'alarm'"></StatusIco>
							</td><!-- 报警状态 -->
							<td class="taC">
								<span v-if="plant.deviceState==null">--</span>
								<span v-else @click.stop="view(plant)" class="curP">
									<StatusIco :id="plant.deviceState" :type="'device'"></StatusIco>
								</span>
							</td>
							<td>{{stationId?plant.systemName||'--':plant.stationName||"--"}}</td>
							<td><span v-if="plant.generationPower==null">--</span><span v-else>{{floatFix(plant.generationPower/1000,2)}}</span></td>
							<td>{{floatFix(plant.generation,2)}}</td>
							<td>
								<div>
									<span v-if="plant.parentDeviceName">{{plant.parentDeviceName}}</span>
									<span v-else-if="!plant.parentDeviceName && plant.parentDeviceType">{{getTypeText(plant.parentDeviceType,'deviceType')}}</span>
									<span v-else>--</span>
								</div>
								<div class="cSub">{{plant.parentDeviceSn?plant.parentDeviceSn:'--'}}</div>
							</td>
								<td><span v-if="plant.parDeviceState==null||plant.parDeviceState==4">--</span>
								<StatusIco v-else :id="plant.parDeviceState" :type="'parDevice'"></StatusIco></td>
							<!--<td>
								<span v-if="plant.parentDeviceNetState==null">--</span>
								<StatusIco v-else :id="plant.parentDeviceNetState" :type="'device'"></StatusIco>
							</td>-->
							 <td :title="timeFormat(plant.collectionTime,'%Y/%m/%d %H:%M:%S UTC',plant.timeZone)">
								<div>{{timeFormat(plant.collectionTime,'%H:%M:%S',plant.timeZone)}}</div>
								<div class="cSub">{{timeFormat(plant.collectionTime,'%Y/%m/%d UTC',plant.timeZone)}}</div>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<no-result v-show="!list.length"></no-result>
	</div>
	<div class="tableBatch bgContent cSub tra-fast inverterListHeight" :class="{disable:!list.length}">
		<Checkbox v-if="stationId" class="mr2x" :text="$t('cmd91',['全选'])" :status="selectAllStatus" :triggerClick="true" @Click="val=>{selectData(val,'all')}"></Checkbox>
		<Pagination :pagination="pagination" :getList="getList"></Pagination>
		<button v-if="stationId" :class="{'disable':selectQty==0}" class="cSub fR bdSub boxR pl1x pr1x sizeS" :title="getLanguageStr('cmd296','批量选择系统')" @click="multiEditDeviceInfo">{{getLanguageStr('cmd296','批量选择系统')}}</button>
	</div>
</div>
</template>
<script>
import * as lib from '@/util/lib.js';

import EditChildSysDevice from '@/view/maintain/part/childSys/EditChildSysDevice.vue';
import StatusIco from '@/components/common/ui/StatusIco.vue';
import Checkbox from '@/components/common/ui/Checkbox.vue';
// import Select from '@/components/common/ui/Select.vue';
import Pagination from '@/components/common/ui/Pagination.vue';
import NoResult from '@/components/common/ui/NoResult';
import Loading from '@/components/common/ui/Loading';
import Confirm from '@/components/common/ui/Confirm.vue';
import DeviceDetail from '@/view/device/operationalAudit/ViewDetail.vue';
import PlantDetailLight from '@/view/maintain/light/plant/ViewDetail.vue';
import PlantDetailWind from '@/view/maintain/wind/plant/ViewDetail.vue';

import * as apiPlantList from '@/api/maintain/plant/list';
import {apiGetDeviceList} from '@/api/maintain/device/main.js';

export default {
	// name: 'inverterList',
	components: {StatusIco, Checkbox, Pagination, NoResult, Loading, Confirm, EditChildSysDevice},
	props: {
		roleCode: {
			type: Array,
			default: () => { []; }
		},
		stationId: {// 指明电站id，将表明在电站详情中使用
			type: Number,
			default: null
		},
		openView: {// 是否使用内建的详情
			type: Boolean,
			default: true
		},
		searchKey: {// 搜索内容
			type: String,
			default: undefined
		},
		powerTypeList: {// 能源类型"PV","WIND"
			type: Array,
			default: undefined
		}
	},
	data () {
		return {
			selectQty: 0,
			// stationId: null,
			systemId: null,
			selectAllStatus: 0,
			pagination: {page: 1, total: 0}, // 分页数据
			stage,
			selectIds: [],
			floatColumn: ['a', 'a'],
			column: ['1', '2', '3', '4', '5', '6', '7', '8'],
			order: {
				property: 'device_sn',
				direction: 'ASC'
			},
			lastOrderBy: 'name',
			list: [],
			active: {
				connectStatus: null,
				alterStatus: null,
				sn: this.searchKey
			},
			level: 0,
			ApiName: ['OperationInverter', 'OperationChildInverter'],
			timeOffset: ''
		};
	},
	watch: {
		searchKey: function (str) {
			this.active.sn = str;
		},
		powerTypeList: function (newValue, oldValue) {
			this.getList();
		}
	},
	methods: {
		getLanguageStr,
		// timeFormat:lib.timeFormat,
		getTypeText: lib.getTypeText,
		floatFix: lib.floatFix,
		convertData: lib.convertData,
		operateModeChange: lib.operateModeChange,
		doPermissions: lib.doPermissions,
		clone (arr) {
			return _.cloneDeep(arr);
		},
		show (data) {
			this.selectQty = 0;
			this.selectAllStatus = 0;
			this.timeOffset = data.timeOffset; // 时区
			this.active = data.status;
			// this.stationId = data.stationId
			this.systemId = data.systemId;
			this.level = data.level;
			if (data.page) this.$set(this.pagination.request, 'page', 1);
			this.getList();
		},
		view: function (data) { // 查看详情
			// trace(data,true)
			if (this.openView) {
				this.$dynamic($(this.$el).parents('#app').find('.frame-main section').first()[0], DeviceDetail, {
					bg: !!this.stationId,
					type: 1,
					outRoleCode: data.roleCode || this.roleCode
				}, {
					Delete: [this.getList.bind(this)]
				}, {}).then(({instance, childInstance}) => {
					childInstance.show(data, '', instance);
				});
			} else {
				this.$emit('View', data);
			}
		},
		viewPlant: function (data) { // 打开所属电站的详情
			// trace(data,true)
			// data.id=data.siteId;//电站详情识别id字段
			let plantDetailPart;
			if (this.powerTypeList && this.powerTypeList.length == 1) {
				switch (this.powerTypeList[0]) {
				case 'PV':
					plantDetailPart = PlantDetailLight;
					break;
				case 'WIND':
					plantDetailPart = PlantDetailWind;
					break;
				}
			}
			this.$dynamic($(this.$el).parents('#app').find('.frame-main section').first()[0], plantDetailPart, {
				bg: true
				// outRoleCode:data.roleCode||this.roleCode
			}, {
				Delete: [this.getList.bind(this)]
			}, {}).then(({instance, childInstance}) => {
				childInstance.show({id: data.siteId}, instance);
			});
		},
		timeFormat (sec, format, timeZoneCode = this.timeOffset) {
			let out = '';
			if (timeZoneCode) {
				out = lib.timeFormat(sec, 'utc', format, {offset: timeZoneCode});
			} else out = lib.timeFormat(sec, 'inc', format);
			return out;
		},
		selectData (val, index) {
			if (index == 'all') {
				this.list = this.list.map(function (item, index) {
					item.isSelect = val;
					return item;
				});
			} else if ($.type(val) == 'boolean') {
				this.list[index].isSelect = val;
			}
			this.selectQty = this.list.filter(function (e) {
				return e.isSelect;
			}).length;
			if (this.selectQty == this.list.length) {
				// $(this.$refs.selectAll.$el).attr("status",2);
				this.selectAllStatus = 2;
			} else if (this.selectQty > 0) {
				this.selectAllStatus = 1;
			} else this.selectAllStatus = 0;
		},
		// view:function(clue,$e){
		// 	let $td=$($e.target).is("td")? $($e.target):$($e.target).parents("td").first();//定位td层
		// 	let qty=$td.find("label input").length;//获取复选框数量
		// 	if(qty==0){
		// 		this.$emit("view",clue.id);
		// 	}
		// },
		getList () {
			this.$refs.Loading.show();
			let pages;
			if (this.level == 0) {
				pages = {page: this.pagination.request.page, size: this.pagination.request.size, deviceState: this.active.deviceState, sn: this.active.sn, 'order.direction': this.order.direction, 'order.property': this.order.property};
			} else {
				pages = {page: this.pagination.request.page, size: this.pagination.request.size, deviceState: this.active.deviceState, sn: this.active.sn, systemId: this.systemId, 'order.direction': this.order.direction, 'order.property': this.order.property};
			}
			if (this.stationId) { // 在电站详情的场景中
				apiPlantList.OperationInverter(this.stationId, pages).then(res => {
					this.list = res.data;
					let {total} = res;
					this.pagination = {...this.pagination, total};
					this.$nextTick(() => {
						lib.fillHeight();
						this.$refs.Loading.hide();
					});
				}, error => {
					this.$refs.Loading.hide();
					!_.isEmpty(error) && this.$notify(error);
				});
			} else { // 在所有电站下查设备
				apiGetDeviceList('INVERTER', {...pages, 'powerTypeList': this.powerTypeList.join(',')}).then(success => {
					// trace(success,true)
					this.list = success.data;
					this.pagination.total = success.total;
					this.$nextTick(() => {
						lib.fillHeight();
						this.$refs.Loading.hide();
					});
				}, error => {
					this.$refs.Loading.hide();
				});
			}
		},
		// 排序
		Order (name) {
			// console.log(name)
			if (this.lastOrderBy == name) {
				if (this.order.direction == 'ASC') {
					this.order.direction = 'DESC';
				} else {
					this.order.direction = 'ASC';
				}
			} else {
				this.order.direction = 'ASC';
			}
			this.order.property = name;
			this.lastOrderBy = name;
			this.getList();
		},
		editDeviceInfo (device) {
			this.$refs.editChildSysDevice.modeChange('single');
			this.$refs.editChildSysDevice.show({
				stationId: this.stationId || device.siteId,
				systemId: device.systemId,
				plantName: device.name,
				deviceId: device.id
			});
		},
		multiEditDeviceInfo () {
			let selectIds = [];	// 声明选择的项
			this.selectIds = [];	// 存放仅id
			selectIds = this.list.filter(function (e) {
				return e.isSelect;
			});	// 过滤被选项
			selectIds.forEach((val, index) => {
				this.selectIds[index] = val.id;
			});
			this.$refs.editChildSysDevice.modeChange('multi');
			this.$refs.editChildSysDevice.show({
				stationId: this.stationId,
				selectIds: this.selectIds
			});
		},
		confirmDel (device) {
			this.$refs.confirm.show({
				text: getLanguageStr('plant274', '确定要将该设备从电站中删除吗?'),
				device
			});
		},
		del (data) {
			apiPlantList.OperationDelete(data.device.systemId, [data.device.id]).then(res => {
				this.getList();
				this.$emit('refreshTree');
				this.$emit('Update');
			}, error => {
				!_.isEmpty(error) && this.$notify(error);
			});
		},
		editSuccess () {
			this.getList();
			this.$emit('refreshTree');
			this.$emit('Update');
		}
		//		selectData:function(val,index){
		//			this.$emit("Select",val,index);
		//		},
		// goOrderBy(...args) {
		// 	this.orderByed = args[0]
		// 	if(this.orderByed === this.lastOrderBy) {
		// 		if(this.orderDirectioned === 'desc') {
		// 			this.orderDirectioned = 'asc'
		// 		}else{
		// 			this.orderDirectioned = 'desc'
		// 		}
		// 	}else{
		// 		this.orderDirectioned = 'desc'
		// 	}
		// 	this.lastOrderBy = this.orderByed
		// 	this.$emit('onOrderBy',this.orderDirectioned,this.orderByed)
		// },
		// _follow(plantIds,isFollow) {	//数组
		// 	function followOrUnfollow(){
		// 		$.each($this.data,(index,value)=>{	//遍历当前列表数据
		// 			// console.log(value.id)
		// 			if (plantIds.indexOf(value.id)>-1) {	//找出包含在选择项中的条目，修改其关注状态
		// 				// console.log(selectLenght)
		// 				$this.$set($this.data[index],'isFollowed',isFollow)
		// 				if (selectLenght--==1) {/*console.log(selectLenght);*/return false}	//找到一个则数量减1。如果循环到最后一个选择项，结束循环，节省资源
		// 			}
		// 		})
		// 	}
		// 	let selectLenght = plantIds.length	//取得选取数量
		// 	let $this = this
		// 	if (isFollow) {	//关注
		// 		apiSetFollow(plantIds).then(res=>{	//api
		// 			followOrUnfollow()
		// 		},{

		// 		})
		// 	}else{	//取消关注
		// 		followOrUnfollow()
		// 	}
		// }
	},
	computed: {
		moreBtnFlag () {
			let buttonPermissions = JSON.parse(window.localStorage.getItem('buttonPermissions'));
			if (!buttonPermissions.includes('A/B/A9') && !buttonPermissions.includes('A/B/A10') && !buttonPermissions.includes('A/B/A6')) {
				return false;
			} else {
				return true;
			}
		}
	},
	mounted () {
		// this.lastOrderBy = this.orderByed;
		lib.fillHeight();
		lib.setScroll($(this.$el).find('[scroll]'));
		if (!this.stationId) this.getList();// 电站详情的设备列表会执行show来开始运作
	}
};
</script>
<style lang="scss" scoped>
$operateMin:4em + 1;
$operate2x:4em * 2 + 1;
$operate3x:4em * 3 + 1;
.operate{
	&.operate-2x>*{width:$operate2x;}
	&.operate-2x[mode]{width:$operate2x;}
	&.operate-2x[mode="min"]{width:$operateMin;
		&:hover{transform:translateX($operateMin - $operate2x);}
	}
	&.operate-3x>*{width:$operate3x;}
	&.operate-3x[mode]{width:$operate3x;}
	&.operate-3x[mode="min"]{width:$operateMin;
		&:hover{transform:translateX($operateMin - $operate3x);}
	}
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/part/childSys/InverterList.vue